import { EventProductMappedToTier } from 'legacy/common/types/models';

/**
 * Sorts tiers based on whether they are private or not.
 * Private tiers come first.
 */
function sortTiers(a: EventProductMappedToTier, b: EventProductMappedToTier) {
  if (a.private === b.private) {
    return 0;
  }

  if (a.private) {
    return -1;
  }

  return 1;
}

export default sortTiers;
